import React, { useState } from 'react';
import OnTestLogo from '../../assets/images/logo-ontest.png';
import './OrganizationLogo.css';

export default function OrganizationLogo({ src, alt = 'Logo da organizadora', variant }) {
  const [failedSource, setFailedSource] = useState(null);
  const customLogo = src && src !== failedSource;

  return (
    <div
      className={`organization-logo-frame${
        ['table', 'heading'].includes(variant) ? ` is-${variant}` : ''
      }`}
    >
      <img
        className="organization-logo"
        src={customLogo ? src : OnTestLogo}
        alt={customLogo ? alt : 'Logo da OnTest'}
        loading={variant === 'table' ? 'lazy' : undefined}
        onError={() => {
          if (customLogo) setFailedSource(src);
        }}
      />
    </div>
  );
}
